import { render, staticRenderFns } from "./ToolbarView.vue?vue&type=template&id=479a1681&"
import script from "./ToolbarView.vue?vue&type=script&lang=js&"
export * from "./ToolbarView.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports